import { PlayerConfig } from '@/interfaces/player-config.interface';

export class AdService {
  public getVastUrl(playerConfig: PlayerConfig) {
    const type = 'live';

    const custParams =
      'sourceId=' +
      playerConfig.sourceId +
      '&type=' +
      type +
      '&accountId=' +
      playerConfig.accountId +
      '&sourceId=' +
      playerConfig.sourceId +
      '&height=' +
      window.innerWidth +
      '&width=' +
      window.innerHeight;

    const uri = playerConfig.advertisment.adserver + '&url=' + playerConfig.parentUrl + '&cust_params=' + decodeURIComponent(custParams);
    return uri;
  }
}

export const adService = new AdService();
